<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="isInstaMed()">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6 m-auto">InstaMed</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="
              merchant.accountDetails.instaMedAccountDetails &&
              hasFinanceRole() &&
              isMerchantActive() &&
              !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Accounts and IDs
          </button>
        </div>
      </legend>
      <div class="col-md-12 mt-3 removePadding" *ngIf="!editable">
        <div class="table-block">
          <div class="recordRow">
            <div class="recordLabel">InstaMed Merchant ID (MID)</div>
            <div id="MerchantID" class="recordValue">
              {{ merchant.accountDetails.instaMedAccountDetails?.merchantId }}
            </div>
          </div>
          <div class="recordRow">
            <div class="recordLabel">Client ID</div>
            <div id="ClientID" class="recordValue">
              {{ merchant.accountDetails.instaMedAccountDetails?.clientId }}
            </div>
          </div>
          <div class="recordRow">
            <div class="recordLabel">Client Secret</div>
            <div id="ClientSecret" class="recordValue">
              {{ merchant.accountDetails.instaMedAccountDetails?.clientSecret }}
            </div>
          </div>
          <div class="recordRow">
            <div class="recordLabel">Store ID (Internal)</div>
            <div id="StoreID" class="recordValue">
              {{ merchant.accountDetails.instaMedAccountDetails?.storeId }}
            </div>
          </div>
          <div class="row recordRow">
            <div class="recordLabel">Account ID</div>
            <div id="AccountID" class="recordValue">
              {{ merchant.accountDetails.instaMedAccountDetails?.accountId }}
            </div>
          </div>
        </div>
        <div class="col-md-12 removePadding">
          <legend class="row ml-sm-0 mt-4 mb-3 borderDivide">
            <div class="borderSeparation">Terminal IDs</div>
          </legend>
          <div class="table-block">
            <div class="recordRow">
              <div class="recordLabel">Patient Portal</div>
              <div id="TerminalIDPP" class="recordValue">
                {{
                  merchant.accountDetails.instaMedAccountDetails
                    ?.instaMedTerminalIDList?.PATIENT_PORTAL
                }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Virtual Visits</div>
              <div id="TerminalIDVV" class="recordValue">
                {{
                  merchant.accountDetails.instaMedAccountDetails
                    ?.instaMedTerminalIDList?.VIRTUAL_VISITS
                }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Engage</div>
              <div id="TerminalIDE" class="recordValue">
                {{
                  merchant.accountDetails.instaMedAccountDetails
                    ?.instaMedTerminalIDList?.ENGAGE
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" *ngIf="editable">
        <form
          name="merchantAddressFormControl"
          class="form-horizontal"
          novalidate
          [formGroup]="instamedFormGroup"
          (submit)="updateInstamedDetails()"
        >
          <app-instamed-details-edit
            [instamedFormGroup]="instamedFormGroup"
          ></app-instamed-details-edit>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="instamedFormGroup.invalid"
            (editableEvent)="receiveEditEvent($event)"
          ></app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
